import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownVisaContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownVisaContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownVisaContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownVisaContracts/${id}`, request)
}

export {get, post, put, patch}
